import { apiRequest } from '@/core';
import { type DashboardData } from '@/types';

export const fetchDashboardDataRequest = async () =>
  apiRequest<DashboardData>({
    endpoint: 'api/dashboard',
  });
